import { useProfissionalIndisponivelDialog } from "./use-profissional-indisponivel-dialog";
import { ProfissionalIndisponivelDialogView } from "./view-profissional-indisponivel-dialog";
import type { ProfissionalIndisponivelDialogProps } from "./types-profissional-indisponivel-dialog";

export function ProfissionalIndisponivelDialog(props: ProfissionalIndisponivelDialogProps) {
  const vm = useProfissionalIndisponivelDialog(props);

  return <ProfissionalIndisponivelDialogView {...props} {...vm} />;
}

export type * from "./types-profissional-indisponivel-dialog";
